import Header from "../components/header";
import Footer from "../components/footers";
import Page from "../assert/images/page404.png"; // If unused, consider removing
import { Helmet } from "react-helmet";

function Careers() {
    return (
        <div>
            <Helmet>
                <title>Careers</title>
                <meta name="ByteForza Careers" content="" />
            </Helmet>

            <Header />

            <div className="subpage">
                <section className="bg-white">
                    <div className="container" data-aos="fade-up">

            {/*<div className="text-center page ptb-120">*/}
            {/*    <h3>We’re always on the lookout for talent.</h3>*/}
            {/*    <p>*/}
            {/*        Please send your resume to{" "}*/}
            {/*        <a href="mailto:careers@byteforza.com">careers@byteforza.com</a> and*/}
            {/*        we will reach out to you.*/}
            {/*    </p>*/}
            {/*</div>*/}

            <div className="card">
                <div className="card-header">
                    <div className="row d-flex align-items-center">
                        <div className="col-md-9">
                            <h1>Computer Programmer – Sterling, VA</h1>
                            <p>
                                We are looking for technically strong and energetic candidates with the following skills and qualities
                            </p>
                        </div>
                        <div className="col-md-3 text-md-center">
                            <a className="btn btn-primary" href="mailto:vimalaa.mahesh@byteforza.com">
                                Apply Now
                            </a>
                        </div>
                    </div>
                </div>

                <div className="card-body collapse show" id="collapseExample">
                    <h5 className="card-title">Qualification</h5>
                     <ul>
                        <li>Bachelor’s Degree or equivalent in Computer Science, MIS, Computer Applications, Information Technology, Engineering or related. Employer deems 3 years of undergraduate study + 1 year experience in the field as equivalent to a bachelor’s degree.</li>
                        <li>Plus 2 years of experience in job offered or in related occupations of Software Engineer, Software Development Team Lead, Consultant, Senior Programmer, Lead Engineer, Senior Executive - Solution Development, Senior Programmer, Software Programmer, Computer Systems Analyst, Software Developer, or related.</li>
                    </ul>

                    <p>
                    </p>

                    <h5 className="card-title">Technical Skills</h5>
                    <p>
                      C#, JavaScript, Angular, ASP.Net Core, Azure, ExtJS and PowerBI
                    </p>
                    <p>
                    </p>

                    <h5 className="card-title">Responsibilities</h5>
                    <ul>
                        <li>Create, modify, and test the code, forms, and script that allow computer applications to run. </li>
                        <li>Work from specifications drawn up by software developers or other individuals.</li>
                        <li>May develop and write computer programs to store, locate, and retrieve specific documents, data, and information.</li>
                    </ul>

                    <p>
                        Please email resumes to{" "}
                        <a href="mailto:vimalaa.mahesh@byteforza.com" target="_blank" rel="noopener noreferrer">
                            vimalaa.mahesh@byteforza.com
                        </a>
                        .
                    </p>

                    <a className="btn btn-primary" href="mailto:vimalaa.mahesh@byteforza.com">
                        Apply Now
                    </a>
                </div>
            </div>
                    </div>
                </section>

            </div>

































            <Footer />
        </div>
    );
}

export default Careers;
